export default function GetYoutubeCode(url) {
    console.log("url: " + url);

    if (url === "youtube.com") {
        return "";
    }

    const BASE_DOMAINS = ["youtube.com", "www.youtube.com", "https://youtube.com", "http://youtube.com"];
    if (BASE_DOMAINS.includes(url)) {
        return "";
    }

    let code = null;
    
    if (url.includes(".be/")) {
        code = url.split(".be/")[1];
    } else if (url.includes("v=")) {
        code = url.split("v=")[1];
    } else {
        return "";
    }

    console.log("code: " + code);
    var ampersandPosition = code.indexOf('&');
    if (ampersandPosition !== -1) {
        code = code.substring(0, ampersandPosition);
    }

    console.log("code: " + code);
    return code;
}

export function GetSpotifyCode(url) {
    console.log("url: " + url);

    if (url === "spotify.com") {
        return "";
    }

    var code = 0;

    if (url.includes("track/")) {
        code = url.split("open.spotify.com/")[1];
    }
    else if (url.includes("playlist/")) {
        code = url.split("open.spotify.com/")[1];
    }
    else {
        return "";
    }

    return code;

    // https://open.spotify.com/playlist/1DALlZllEq2WptnCCIxTcY?si=e9449ed4f2e14bff
    // https://open.spotify.com/track/3BuWlLm8iGGNiYewY39IpF?si=f887d9b345794b8c


    console.log("code: " + code);
    var ampersandPosition = code.indexOf('&');
    if (ampersandPosition !== -1) {
        code = code.substring(0, ampersandPosition);
    }

    console.log("code: " + code);
    return code;
}
